import React from "react";
import "./CustomInput.css";

function CustomInput() {
  return (
    <input type="text" placeholder="Full Name" className="ci_main_container" />
  );
}

export default CustomInput;
